/**
 * The panel scaffolding, React edition of ui/shell.ts's builders - the same
 * classes, so the existing stylesheet keeps carrying the look.
 */

import type { ReactNode } from 'react'
import type { Readout } from '../../assistant/types'
import { STATUS } from '../palette'

/** A titled block with an underlined heading, matching the existing panels. */
export function Section({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="section">
      <h3>{title}</h3>
      {children}
    </div>
  )
}

/** Small explanatory paragraph under a heading. */
export function Note({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        fontSize: 11,
        color: 'var(--ink-muted)',
        lineHeight: 1.5,
        margin: '6px 0 9px',
      }}
    >
      {children}
    </div>
  )
}

const STATE_ICON = { good: '●', warning: '▲', critical: '■' } as const

/** One stat tile - the same rendering ui/AssistantPanel.ts's statTile draws. */
export function StatTile({ r }: { r: Readout }) {
  return (
    <div className={`stat ${r.state ?? ''}`}>
      <div className="label">{r.label}</div>
      <div className="value">
        {r.state && (
          <span className="state-icon" style={{ color: STATUS[r.state] }}>
            {STATE_ICON[r.state]}
          </span>
        )}
        {r.value}
      </div>
      {r.note && <div className="note">{r.note}</div>}
    </div>
  )
}

/** A grid of stat tiles - a projection now, no set() to call. */
export function StatGrid({ tiles }: { tiles: Readout[] }) {
  return (
    <div className="grid-3">
      {tiles.map((r, i) => (
        <StatTile key={`${r.label}-${i}`} r={r} />
      ))}
    </div>
  )
}
